var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.89481 7.97056C3.89481 7.03311 3.13486 6.27315 2.19741 6.27315C1.25995 6.27315 0.5 7.03311 0.5 7.97056C0.5 8.90801 1.25995 9.66797 2.19741 9.66797C3.13486 9.66797 3.89481 8.90801 3.89481 7.97056Z",
    fill: "#9A9FA4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83622 7.97056C9.83622 7.03311 9.07629 6.27315 8.13881 6.27315C7.20134 6.27315 6.44141 7.03311 6.44141 7.97056C6.44141 8.90801 7.20134 9.66797 8.13881 9.66797C9.07629 9.66797 9.83622 8.90801 9.83622 7.97056Z",
    fill: "#9A9FA4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0788 6.27315C15.0162 6.27315 15.7762 7.03311 15.7762 7.97056C15.7762 8.90801 15.0162 9.66797 14.0788 9.66797C13.1413 9.66797 12.3813 8.90801 12.3813 7.97056C12.3813 7.03311 13.1413 6.27315 14.0788 6.27315Z",
    fill: "#9A9FA4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.89481 2.0272C3.89481 1.08972 3.13486 0.329796 2.19741 0.329796C1.25995 0.329796 0.5 1.08972 0.5 2.0272C0.5 2.96468 1.25995 3.72461 2.19741 3.72461C3.13486 3.72461 3.89481 2.96468 3.89481 2.0272Z",
    fill: "#9A9FA4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.13881 0.329796C9.07629 0.329796 9.83622 1.08972 9.83622 2.0272C9.83622 2.96468 9.07629 3.72461 8.13881 3.72461C7.20134 3.72461 6.44141 2.96468 6.44141 2.0272C6.44141 1.08972 7.20134 0.329796 8.13881 0.329796Z",
    fill: "#9A9FA4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7762 2.0272C15.7762 1.08972 15.0162 0.329796 14.0788 0.329796C13.1413 0.329796 12.3813 1.08972 12.3813 2.0272C12.3813 2.96468 13.1413 3.72461 14.0788 3.72461C15.0162 3.72461 15.7762 2.96468 15.7762 2.0272Z",
    fill: "#9A9FA4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.ed9a56d94ee5200704c71542ebc4b7df.svg";
export { ForwardRef as ReactComponent };